import React, { useEffect, useState } from 'react';
import {queries} from "../Infrastructure/const/queries";

const FakeReg = () => {
    const [isSubscribed, setIsSubscribed] = useState(false);

    useEffect(() => {
        // Регистрация Service Worker
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.register('/service-worker.js')
                .then(reg => console.log('Service Worker зарегистрирован', reg))
                .catch(err => console.error('Ошибка регистрации SW', err));
        }
    }, []);

    const subscribeUser = async () => {
        try {
            const registration = await navigator.serviceWorker.ready;

            const subscription = await registration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: urlBase64ToUint8Array('BNBgQnXv8kIuUQ4SItGp8WNZOfATTSjAxeATePlaQnO7091CFK0Vh6tNiWbe-uPPJJ4pwteSAFMguSoAUk59RpY'), // вставь свой публичный ключ
            });

            // Отправка подписки на сервер
            await fetch(`${queries.baseURL}api/push/subscribe`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem("userToken")}`
                }
                ,
                body: JSON.stringify(subscription),
            });

            setIsSubscribed(true);
            console.log('Подписка отправлена на сервер', subscription);
        } catch (err) {
            console.error('Ошибка подписки', err);
        }
    };



    const sendTestNotification = async () => {
        try {
            const res = await fetch('http://127.0.0.1:8000/api/push/test', {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem("userToken")}`
                },
            });
            const data = await res.json();
            console.log('Тестовая нотификация:', data);
        } catch (err) {
            console.error('Ошибка тестовой нотификации', err);
        }
    };

    return (
        <div className="p-4">
            <h1 className="text-xl font-bold mb-4">Тест Web Push</h1>

            <button
                className="bg-blue-500 text-white px-4 py-2 rounded mr-2"
                onClick={subscribeUser}
            >
                {isSubscribed ? 'Вы подписаны' : 'Подписаться на уведомления'}
            </button>

            <button
                className="bg-green-500 text-white px-4 py-2 rounded"
                onClick={sendTestNotification}
            >
                Отправить тестовую нотификацию
            </button>
        </div>
    );
};

export default FakeReg;

// 🔹 Вспомогательная функция для конвертации VAPID key
function urlBase64ToUint8Array(base64String: string) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}
